/** Where the bring-your-own-agent (macrod) setup is documented. */
export const BYOA_DOCS_URL = 'https://docs.macro.com/AI/bring-your-own';

/** The coding agents macrod can bring to Macro, as the roster page names them. */
export const BYOA_AGENTS = [
  'Claude Code',
  'Codex',
  'OpenCode',
  'Hermes',
  'OpenClaw',
];
